(() => {
  const initReferenceProduct = (root = document) => {
    root.querySelectorAll('.reference-gallery').forEach(gallery => {
      if (gallery.dataset.referenceReady || !gallery.activateMedia) return;
      gallery.dataset.referenceReady = 'true';
      const media = [...gallery.querySelectorAll('.product-media[data-media-id]')];
      const originalActivate = gallery.activateMedia;
      gallery.activateMedia = id => {
        originalActivate(id);
        const index = media.findIndex(item => !item.hidden);
        const count = gallery.querySelector('[data-media-index]');
        if (count) count.textContent = String(index + 1);
      };
      gallery.querySelectorAll('[data-gallery-controls]').forEach(controls => { controls.hidden = false; });
      const move = step => {
        if (!media.length) return;
        const index = media.findIndex(item => !item.hidden);
        gallery.activateMedia(media[(index + step + media.length) % media.length].dataset.mediaId);
      };
      gallery.querySelectorAll('[data-media-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.mediaStep))));
      const stage = gallery.querySelector('.reference-gallery__stage');
      let start;
      stage?.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || event.target.closest('video, iframe, model-viewer, [data-gallery-controls]')) return;
        start = {x: event.clientX, y: event.clientY};
      }, {passive: true});
      stage?.addEventListener('pointerup', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) move(dx < 0 ? 1 : -1);
      }, {passive: true});
      stage?.addEventListener('pointercancel', () => { start = null; }, {passive: true});
      gallery.activateMedia(media.find(item => !item.hidden)?.dataset.mediaId);
    });
    root.querySelectorAll('.reference-purchase[data-product-form]').forEach(form => {
      if (form.dataset.referenceReady) return;
      form.dataset.referenceReady = 'true';
      const quantity = form.querySelector('[name="quantity"]');
      const selector = form.querySelector('[name="id"]');
      const quantityBox = form.querySelector('.reference-quantity');
      const buttons = [...form.querySelectorAll('[data-quantity-step]')];
      const syncQuantity = () => {
        if (!quantity) return;
        const value = Number(quantity.value);
        const min = Number(quantity.min || 1);
        const max = quantity.max ? Number(quantity.max) : Infinity;
        buttons.forEach(button => {
          button.hidden = false;
          button.disabled = Number(button.dataset.quantityStep) < 0 ? value <= min : value >= max;
        });
      };
      quantityBox?.setAttribute('data-quantity-ready', '');
      buttons.forEach(button => button.addEventListener('click', () => {
        if (!quantity) return;
        if (Number(button.dataset.quantityStep) < 0) quantity.stepDown(); else quantity.stepUp();
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      }));
      quantity?.addEventListener('input', syncQuantity);
      quantity?.addEventListener('change', syncQuantity);
      const syncVariantExtra = () => {
        syncQuantity();
        const sku = form.querySelector('[data-product-sku]');
        const selected = selector?.options[selector.selectedIndex];
        const valid = !selector?.disabled && selected;
        form.dataset.variantAvailable = String(Boolean(valid && selected.dataset.available === 'true'));
        if (sku) {
          sku.querySelector('span').textContent = valid ? selected.dataset.sku || '' : '';
          sku.hidden = !valid || !selected.dataset.sku;
        }
      };
      selector?.addEventListener('change', syncVariantExtra);
      form.querySelectorAll('[data-product-option]').forEach(select => select.addEventListener('change', syncVariantExtra));
      syncVariantExtra();
      form.addEventListener('submit', event => {
        if (selector?.disabled || form.querySelector('[type="submit"]')?.disabled || !quantity?.checkValidity()) {
          event.preventDefault();
          quantity?.reportValidity();
        }
      });
      syncQuantity();
    });
    root.querySelectorAll('[data-open-sizing]').forEach(link => {
      if (link.dataset.referenceReady) return;
      link.dataset.referenceReady = 'true';
      link.addEventListener('click', event => {
        const details = document.getElementById(link.hash.slice(1));
        if (!details) return;
        event.preventDefault();
        details.open = true;
        details.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        details.querySelector('summary')?.focus({preventScroll: true});
      });
    });
    root.querySelectorAll('.reference-product').forEach(section => {
      if (section.dataset.referenceReady) return;
      section.dataset.referenceReady = 'true';
      const form = section.querySelector('[data-product-form]');
      const sticky = section.querySelector('[data-sticky-purchase]');
      if (!form || !sticky) return;
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, {threshold: 0});
      observer.observe(form);
      const updateSticky = () => {
        const price = section.querySelector('[data-product-price]');
        sticky.querySelector('[data-sticky-price]').textContent = price?.textContent || '';
      };
      form.addEventListener('change', updateSticky);
      section.querySelector('[data-return-to-purchase]')?.addEventListener('click', () => {
        form.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        const target = form.querySelector('select[data-product-option]:not([hidden])') || form.querySelector('[type="submit"]');
        target?.focus({preventScroll: true});
      });
      updateSticky();
    });
    root.querySelectorAll('.reference-films').forEach(section => {
      if (section.dataset.referenceReady) return;
      section.dataset.referenceReady = 'true';
      const track = section.querySelector('[data-reference-rail]');
      section.querySelectorAll('[data-rail-controls]').forEach(controls => { controls.hidden = false; });
      section.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        track?.scrollBy({left: Number(button.dataset.railStep) * (track.firstElementChild?.getBoundingClientRect().width + 15 || 205), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.pause();
      }), {threshold: 0});
      section.querySelectorAll('video').forEach(video => observer.observe(video));
    });
  };
  const updateRecentlyViewed = () => {
    const data = document.querySelector('[data-viewed-product]');
    const container = document.querySelector('[data-recently-viewed]');
    if (!data || !container) return;
    try {
      const current = JSON.parse(data.textContent);
      const safeImage = value => {
        if (!value) return true;
        if (typeof value !== 'string') return false;
        try {
          const url = new URL(value, window.location.origin);
          return url.origin === window.location.origin && /^https?:$/.test(url.protocol) || url.protocol === 'https:' && url.hostname === 'cdn.shopify.com';
        } catch (_) { return false; }
      };
      const safeProduct = value => value && typeof value.title === 'string' && typeof value.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^?#]+$/i.test(value.url) && safeImage(value.image);
      const previous = JSON.parse(sessionStorage.getItem('reference-viewed-products') || '[]');
      const products = Array.isArray(previous) ? previous.filter(value => safeProduct(value) && value.id !== current.id).slice(0, 4) : [];
      const target = container.querySelector('[data-viewed-products]');
      products.forEach(product => {
        const article = document.createElement('article');
        article.className = 'product-card reference-card';
        const link = document.createElement('a');
        link.className = 'product-card__image';
        link.href = product.url;
        link.setAttribute('aria-label', product.title);
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.width = 600;
          image.height = 750;
          image.loading = 'lazy';
          link.append(image);
        }
        const info = document.createElement('div');
        info.className = 'product-card__info';
        const heading = document.createElement('h3');
        const text = document.createElement('a');
        text.href = product.url;
        text.textContent = product.title;
        heading.append(text);
        info.append(heading);
        article.append(link, info);
        target.append(article);
      });
      container.hidden = products.length === 0;
      if (safeProduct(current)) sessionStorage.setItem('reference-viewed-products', JSON.stringify([current, ...products].slice(0, 5)));
    } catch (_) {}
  };
  document.addEventListener('pointerover', event => {
    const swatch = event.target.closest('[data-card-preview]');
    const card = swatch?.closest('[data-product-card]');
    const image = card?.querySelector('.reference-card__primary');
    if (!image) return;
    if (!image.dataset.originalSrc) {
      image.dataset.originalSrc = image.src;
      image.dataset.originalSrcset = image.srcset;
    }
    card.dataset.previewActive = 'true';
    image.srcset = '';
    image.src = swatch.dataset.cardPreview;
  });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest('[data-product-card]');
    if (!card || card.contains(event.relatedTarget)) return;
    const image = card.querySelector('.reference-card__primary');
    if (image?.dataset.originalSrc) {
      image.src = image.dataset.originalSrc;
      image.srcset = image.dataset.originalSrcset || '';
    }
    delete card.dataset.previewActive;
  });
  document.addEventListener('DOMContentLoaded', () => { initReferenceProduct(); updateRecentlyViewed(); });
  document.addEventListener('shopify:section:load', event => initReferenceProduct(event.target));
})();
